import DialogMessage from "./strings";

//const RootPrefix = "/service/sarcopenia";
const RootPrefix = "";

const Constants = {
  DialogMessage,
  RootPrefix,
};

export default Constants;
